import {
	AfterViewInit,
	Component,
	Input,
	OnDestroy,
	OnInit,
	ViewChild
} from '@angular/core';
import { InvoicesDataProvider } from '@services/invoice/invoices-data-service/invoices.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import {
	DataToGetInvoice,
	Invoice,
	InvoiceDataToSave,
	InvoiceIdAndDate,
	IssueDateFormat,
	MainInfoData,
	Payment,
	PaymentSchedule
} from '@models/invoice.model';
import {
	Contract,
	ContractQuestionData,
	IModalAction,
	Job,
	ListItem,
	Package,
	Product,
	Question,
	Summary,
	CurrencyAndTaxes,
	BootstrapSettings,
	PropsAction,
	ContractPayload,
	QuotePayments,
	InvoicePayment
} from '@models/models';
import { finalize, map, takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { InvoiceServiceProvider } from '@services/invoice/invoice-service/invoice.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';
import { Observable } from 'rxjs/Observable';
import { JobsDataServiceProvider } from '@services/job/jobs.data.service';
import { SettingsProvider } from '@services/settings/settings';
import { TemplatesDataProvider } from '@services/data-services/templates-data-service/templates.data.service';
import { ContractsDataProvider } from '@services/contract/contracts.data.service';
import { PaymentSchedulesDataProvider } from '@services/payments/payments-schedules-data-service/payments-schedules.data.service';
import { QuoteUpdateService } from '@services/quote/quote-update.service';
import { ProductPackagesDataServiceProvider } from '@services/settings/product-packages.data.service';
import { Location } from '@angular/common';
import { PaymentScheduleComponent } from '@web-components/quotes/common/payment-schedule/payment-schedule';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { SaveAsTemplateModalComponent } from '@web-components/quotes/modals/save-as-template-modal/save-as-template-modal.component';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SaveNewTemplateModalComponent } from '@web-components/quotes/modals/save-new-template-modal/save-new-template-modal.component';
import {
	QtBaseData,
	QtItemPayload,
	QTSaveDataPayload,
	QtTemplateListItem
} from '@models/qt-templates.model';
import { diff } from 'deep-object-diff';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { EditContractModalComponent } from '@web-components/contract/edit-contract-modal/edit-contract-modal.component';
import { ValidationProvider } from '@services/helpers/validation.service';
import { QuoteInvoiceTemplatesDataService } from '@services/quote-invoice-templates/quote-invoice-templates.data.service';
import { QuoteInvoiceTemplatesService } from '@services/quote-invoice-templates/quote-invoice-templates.service';

@Component({
	selector: 'invoice-update',
	template: require('./invoice-update.html'),
	styles: [require('./invoice-update.scss')]
})
export class InvoiceUpdateComponent
	implements OnInit, AfterViewInit, OnDestroy {
	@Input() dataToGetInvoice: DataToGetInvoice;
	@ViewChild('paymentScheduleComponent')
	paymentScheduleComponent: PaymentScheduleComponent;
	@ViewChild('invoiceTemplateSelect')
	invoiceTemplateSelect: { nativeElement: HTMLSelectElement };

	invoiceTemplatesAvailable: boolean;

	invoice: Invoice = <Invoice>{};
	job: Job;

	editInvoice: boolean;
	chosenPackages: Array<Package> = [];
	datePlaceholder: string;

	// split data from invoice DTO
	issueDate: IssueDateFormat;
	poNumber: number;
	contractQuestionData: ContractQuestionData;
	currencyAndTax: CurrencyAndTaxes;
	payments: Array<Payment> = [];
	paymentsFromServer: Array<Payment> = [];
	paymentSchedule: PaymentSchedule;
	contract: Contract;
	contractTextSnapshot: string;
	contractsTemplates: Array<ListItem> = [];
	linkedContract: Contract;
	questionnaire: Question;
	questionnaireTemplates: Array<ListItem> = [];
	invoiceTemplates: Array<QtTemplateListItem> = [];
	paymentScheduleNames;
	defaultPaymentScheduleNames;
	selectedPaymentSchedule;
	productsNames: Array<ListItem> = [];
	discountsNames: Array<ListItem> = [];
	products: Array<Product> = [];
	discounts: Array<Product> = [];
	summary: Summary;

	// IDs
	leadId: number;
	jobId: number;
	paymentScheduleTemplateId: number;
	paymentScheduleIdFromServer: number;

	// Data to save
	questionnaireToSaveId = '-1';
	contractToSaveId = '-1';
	contractToSave = null;
	currentContractId: number;
	notesToSave: string = null;
	paymentsToSave: Array<Payment> = [];
	mainInfoDataToSave: MainInfoData;

	initialDataAsTemplate: QtItemPayload = null;
	selectedInvoiceTemplate: QtItemPayload;
	selectedInvoiceTemplateId = '-1';
	currencyFlag = false;
	contractFlag = false;

	loadingTemplate: boolean;
	buttonDisable: boolean;
	private unsubscribe = new Subject();

	constructor(
		private invoicesDataService: InvoicesDataProvider,
		private messageService: MessageService,
		private invoiceService: InvoiceServiceProvider,
		private quoteDataService: QuotesDataProvider,
		private jobDataService: JobsDataServiceProvider,
		private settingsService: SettingsProvider,
		private templatesDataService: TemplatesDataProvider,
		private contractDataService: ContractsDataProvider,
		private paymentsSchedulesDataService: PaymentSchedulesDataProvider,
		private productPackagesDataService: ProductPackagesDataServiceProvider,
		private quoteUpdateService: QuoteUpdateService,
		private stringModifierService: StringModifierServiceProvider,
		private timeService: TimeServiceProvider,
		private location: Location,
		private modalService: SNModalService,
		private qtTemplatesDataService: QuoteInvoiceTemplatesDataService,
		private qtTemplatesService: QuoteInvoiceTemplatesService,
		private contractsDataService: ContractsDataProvider,
		private validationService: ValidationProvider
	) {}

	ngOnInit(): void {
		if (this.dataToGetInvoice.invoiceID && this.dataToGetInvoice.isJob) {
			this.jobId = this.dataToGetInvoice.id;
			this.getInvoiceSourceData(this.dataToGetInvoice.invoiceID);
			this.editInvoice = true;
		} else if (
			this.dataToGetInvoice.invoiceID &&
			!this.dataToGetInvoice.isJob
		) {
			this.getJobId(true);
			this.editInvoice = true;
		} else if (
			!this.dataToGetInvoice.invoiceID &&
			this.dataToGetInvoice.isJob
		) {
			this.jobId = this.dataToGetInvoice.id;
			this.showNewInvoice(this.jobId);
		} else {
			this.getJobId(false);
		}
		this.getProductsTemplates();
		this.getBootstrapSettings();
	}

	ngAfterViewInit(): void {
		this.registerUpdateProductSubscription();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.quoteUpdateService.setNextUpdateProduct(null, null);
	}

	addProduct(): void {
		this.products.push(QuoteUpdateService.setEmptyProduct('ADD_ON'));
		this.updateInvoiceSummary(true);
	}

	addNewDiscount(): void {
		this.discounts.push(QuoteUpdateService.setEmptyProduct('GIFT'));
		this.updateInvoiceSummary(true);
	}

	saveInvoice(): void {
		this.buttonDisable = true;
		if (!this.validateInvoice()) {
			this.buttonDisable = false;
			return;
		}

		const data = this.gatherDataToSaveInvoice();

		if (this.editInvoice) {
			this.updateInvoice(data);
		} else {
			this.createInvoice(data);
		}
	}

	back(): void {
		this.location.back();
	}

	setQuestionnaire(questionnaireId: string): void {
		this.questionnaireToSaveId = questionnaireId;
	}

	setContract(contractId: string): void {
		this.contractTextSnapshot = null;
		this.contractToSaveId = contractId;
		this.getContractToEdit(contractId);
	}

	disableButtons(isDisable: boolean): void {
		this.buttonDisable = isDisable;
	}

	setPaymentScheduleId(payments): void {
		this.paymentScheduleTemplateId = +payments.id;
		this.paymentsToSave = payments.payments;
	}

	onProductChange(): void {
		this.updateInvoiceSummary(true);
	}

	confirmApplyInvoiceTemplate(templateId: string): void {
		if (this.isTemplateDataDiff()) {
			this.confirmTemplateChange()
				.then((): void => this.applyQuoteTemplate(templateId))
				.catch((): void => {
					this.invoiceTemplateSelect.nativeElement.value = this.selectedInvoiceTemplateId;
				});
		} else {
			this.applyQuoteTemplate(templateId);
		}
	}

	private applyQuoteTemplate(templateId: string): void {
		this.selectedInvoiceTemplateId = templateId;

		if (templateId === '-1') {
			this.resetTemplateData();
			return;
		}

		this.loadingTemplate = true;
		this.qtTemplatesDataService
			.loadQtTemplate(templateId, 'INVOICE')
			.pipe(
				takeUntil(this.unsubscribe),
				finalize((): boolean => (this.loadingTemplate = false))
			)
			.subscribe(
				({ data }): void => this.applyQuoteTemplateData(data),
				(error): void => {
					this.selectedInvoiceTemplateId = '-1';
					this.messageService.handleError(error);
				}
			);
	}

	private applyQuoteTemplateData(data: QtItemPayload): void {
		this.selectedInvoiceTemplate = JSON.parse(JSON.stringify(data));
		this.modifyContractBodyForDiff(data.contractTemplate);
		this.modifyProductsForDiff(data.products);
		this.selectedInvoiceTemplate.notes =
			this.selectedInvoiceTemplate.notes || '';

		this.setProductsAndDiscounts(data.products);
		this.notesToSave = data.notes;
		this.invoice.notes = data.notes;

		this.getTemplatePayments(data);
		if (data.payments) {
			this.payments = this.addMissDateField(data.payments);
		} else {
			this.payments = [];
		}

		this.contractToSaveId = data.contractTemplate
			? data.contractTemplate.id.toString()
			: '-1';
		this.questionnaireToSaveId = data.questionnaireTemplate
			? data.questionnaireTemplate.id.toString()
			: '-1';

		this.contractTextSnapshot = null;
		this.getContractToEdit(this.contractToSaveId);
		this.updateInvoiceSummary(true);
	}

	private getTemplatePayments(data) {
		const rule = data.paymentsRule;
		if (rule) {
			switch (rule.strategy) {
				case 'NONE':
					this.paymentScheduleTemplateId = -1;
					break;
				case 'NO_SPLIT_PAYMENTS':
					this.paymentScheduleTemplateId = -2;
					break;
				case 'BY_PAYMENT_SCHEDULER':
					const paymentScdl = rule.paymentSchedule;
					if (paymentScdl) {
						const check = this.paymentScheduleNames.some(
							el => el.id === paymentScdl.id
						);
						if (!check) {
							this.paymentScheduleNames.push({
								...paymentScdl
							});
						}
						this.paymentScheduleTemplateId = paymentScdl.id.toString();
					}
					break;
				default:
					this.paymentScheduleTemplateId = -2;
			}
		} else {
			if (data.paymentSchedule) {
				const check = this.paymentScheduleNames.some(
					el => el.id === data.paymentSchedule.id
				);
				if (!check) {
					this.paymentScheduleNames.push({
						...data.paymentSchedule
					});
				}
			}
			this.paymentScheduleTemplateId = data.paymentSchedule
				? data.paymentSchedule.id.toString()
				: -1;
		}
	}

	private resetTemplateData(): void {
		let emptyTemplateData: QtItemPayload = null;

		if (this.editInvoice) {
			emptyTemplateData = JSON.parse(
				JSON.stringify(this.initialDataAsTemplate)
			);
		} else {
			this.selectedPaymentSchedule = null;
			const desiredEmptyProduct = QuoteUpdateService.setEmptyProduct('PACKAGE');
			desiredEmptyProduct.mandatory = true;

			emptyTemplateData = QuoteInvoiceTemplatesService.getEmptyQtItem(
				'INVOICE',
				QuoteUpdateService.setEmptyProduct('ADD_ON')
			);
		}
		this.applyQuoteTemplateData(emptyTemplateData);
	}

	private isTemplateDataDiff(): boolean {
		const dataDiff = diff(
			this.qtTemplatesService.prepareQuoteInvoiceDataForDiff(
				this.selectedInvoiceTemplate
			),
			this.qtTemplatesService.prepareQuoteInvoiceDataForDiff(
				this.gatherQtDataForDiff()
			)
		);
		return !!Object.keys(dataDiff).length;
	}

	private gatherQtDataForDiff(): Partial<QtItemPayload> {
		const paymentSchedule =
			this.paymentScheduleTemplateId === -1 ||
			this.paymentScheduleTemplateId === -2
				? null
				: this.qtTemplatesService.findTemplateItemById(
						this.paymentScheduleNames,
						this.paymentScheduleTemplateId
				  );

		const questionnaireTemplate =
			this.questionnaireToSaveId === '-1'
				? null
				: this.qtTemplatesService.findTemplateItemById(
						this.questionnaireTemplates,
						this.questionnaireToSaveId
				  );

		return {
			...this.selectedInvoiceTemplate,
			products: this.qtTemplatesService.prepareProductsForDiffInvoices([
				...this.products,
				...this.discounts
			]),
			notes: this.notesToSave || '',
			contractTemplate: this.contractToSave
				? {
						id: this.contractToSave.id,
						text: this.contractToSave.text
				  }
				: null,
			paymentSchedule,
			questionnaireTemplate
		};
	}

	private modifyContractBodyForDiff(contract: Contract): void {
		if (contract) {
			this.selectedInvoiceTemplate.contractTemplate = {
				id: contract.id,
				text: contract.text
			};
		}
	}

	private modifyProductsForDiff(products: Array<Product>): void {
		if (products.length) {
			this.selectedInvoiceTemplate.products = this.qtTemplatesService.prepareProductsForDiffInvoices(
				products
			);
		}
	}

	private confirmTemplateChange(): Promise<void> {
		return new Promise((resolve, reject): void => {
			const modal = this.modalService.openModal(ConfirmGeneralModalComponent);
			modal.componentInstance.text =
				'This invoice has unsaved changes. Are you sure you want to replace it with a template? Some data may be lost.';
			modal.componentInstance.buttons = [
				{
					text: 'Yes',
					color: 'success',
					size: 'lg',
					action: 'APPLY_TEMPLATE'
				},
				{
					text: 'No',
					color: 'default',
					size: 'lg',
					action: 'CANCEL'
				}
			];

			modal.result.then((action: string): void => {
				if (action === 'APPLY_TEMPLATE') {
					resolve();
				}
				if (action === 'CANCEL') {
					reject();
				}
			});
		});
	}

	saveAsTemplate(): void {
		const payload = this.validateAndGatherTemplate('Test Name');

		if (payload) {
			if (!this.validateContractEditing()) {
				return;
			}

			const modal = this.modalService.openModal(SaveAsTemplateModalComponent, {
				windowClass: 'ng-bootstrap-modal'
			});
			modal.componentInstance.templateList = this.invoiceTemplates;
			modal.componentInstance.templateTypeName = 'Invoice';
			modal.componentInstance.templateNameTitle = 'Invoice';
			modal.componentInstance.breadcrumbsText =
				'Invoice Templates will be saved in Settings > Quote & Invoice Templates';

			const modalSubscription$ = this.modalService.modalData.subscribe(
				(data: IModalAction<ListItem>): void => {
					const closeModal = (): void => {
						this.modalService.closeModalByRef(modal, modalSubscription$);
					};

					this.handleSaveAsTemplateResponse(
						data,
						modal,
						payload,
						closeModal.bind(this)
					);
				}
			);
		}
	}

	saveNewTemplate(payload: QTSaveDataPayload): void {
		const modal = this.modalService.openModal(SaveNewTemplateModalComponent, {
			windowClass: 'ng-bootstrap-modal'
		});
		modal.componentInstance.templateTypeName = 'Invoice';
		modal.componentInstance.templateNameTitle = 'Invoice';
		modal.componentInstance.breadcrumbsText =
			'Invoice Templates will be saved in Settings > Quote & Invoice Templates';
		modal.componentInstance.templateNameProp = this.selectedInvoiceTemplate.name;

		const modalSubscription$ = this.modalService.modalData.subscribe(
			(data: IModalAction<string>): void => {
				const closeModal = (): void => {
					this.modalService.closeModalByRef(modal, modalSubscription$);
				};

				this.handleSaveNewTemplateResponse(
					data,
					modal,
					payload,
					closeModal.bind(this)
				);
			}
		);
	}

	private handleSaveNewTemplateResponse(
		data: IModalAction<string>,
		modalRef: NgbModalRef,
		payload: QTSaveDataPayload,
		closeModal: Function
	): void {
		if (data.action === 'CLOSE') {
			this.saveAsTemplate();
			closeModal();
		}

		if (data.action === 'SAVE') {
			if (!data.props) {
				if (!data.props || (data.props && !data.props.trim())) {
					this.messageService.showToaster(
						'e_4',
						'quoteInvoiceTemplates',
						'invoice'
					);
					return null;
				}
			}

			const dataToSave = JSON.parse(JSON.stringify(payload));
			dataToSave.data.name = data.props;

			modalRef.componentInstance.btnDisable = true;
			this.qtTemplatesDataService
				.saveTemplate('INVOICE', dataToSave)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize(
						(): boolean => (modalRef.componentInstance.btnDisable = false)
					)
				)
				.subscribe(
					({ data }): void => {
						closeModal();
						this.loadInvoiceTemplates();
						this.messageService.showToaster(
							's_6',
							'quoteInvoiceTemplates',
							data.name
						);
						this.selectedInvoiceTemplateId = data.id;
						this.selectedInvoiceTemplate.name = data.name;
						localStorage.setItem('keyToScroll', 'invoice');
						window.open(`${location.origin}/settings/quote_invoice_templates`);
					},
					(error): void => this.messageService.handleError(error)
				);
		}
	}

	private handleSaveAsTemplateResponse(
		data: IModalAction<ListItem>,
		modalRef: NgbModalRef,
		payload: QTSaveDataPayload,
		closeModal: Function
	): void {
		if (data.action === 'CLOSE') {
			closeModal();
		}

		if (data.action === 'SAVE') {
			closeModal();
			this.saveNewTemplate(payload);
		}

		if (data.action === 'OVERWRITE') {
			if (!data.props) {
				this.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
				return;
			}

			const dataToSave = JSON.parse(JSON.stringify(payload));
			dataToSave.data.name = data.props.name;

			modalRef.componentInstance.btnDisable = true;
			this.qtTemplatesDataService
				.editTemplate('INVOICE', data.props.id.toString(), dataToSave)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize(
						(): boolean => (modalRef.componentInstance.btnDisable = false)
					)
				)
				.subscribe(
					({ data }): void => {
						this.messageService.showToaster(
							's_1',
							'quoteInvoiceTemplates',
							'invoice'
						);
						this.selectedInvoiceTemplateId = data.id;
						closeModal();
					},
					(error): void => this.messageService.handleError(error)
				);
		}
	}

	private validateContractEditing(): boolean {
		if (
			this.contractTextSnapshot &&
			this.validationService.trimHTML(this.contractTextSnapshot) !==
				this.validationService.trimHTML(this.contractToSave.text)
		) {
			this.confirmEditingContract(this.contractToSave);
			return false;
		}
		return true;
	}

	private confirmEditingContract(contract: Contract): void {
		if (contract) {
			const modal = this.modalService.openModal(SaveAsTemplateModalComponent, {
				windowClass: 'ng-bootstrap-modal'
			});
			modal.componentInstance.templateList = this.contractsTemplates;
			modal.componentInstance.templateTypeName = 'Contract';
			modal.componentInstance.templateNameTitle = 'Contract';
			modal.componentInstance.breadcrumbsText =
				'Contract Templates will be saved in Settings > Contract Templates';
			modal.componentInstance.detailedDescription =
				'Your contract has been edited and will need to be saved as a Contract Template.';

			const modalSubscription$ = this.modalService.modalData.subscribe(
				(res: IModalAction<ListItem>): void => {
					if (res.action === 'CLOSE') {
						this.modalService.closeModalByRef(modal, modalSubscription$);
					}

					if (res.action === 'SAVE') {
						this.modalService.closeModalByRef(modal, modalSubscription$);
						this.saveNewContractTemplate(contract);
					}

					if (res.action === 'OVERWRITE') {
						if (!res.props) {
							this.messageService.showToaster('e_2', 'quoteInvoiceTemplates');
							return;
						}

						modal.componentInstance.btnDisable = true;
						const newContract = {
							...res.props,
							text: this.contractToSave.text
						} as ContractPayload;

						this.contractsDataService
							.overwriteContractTemplate(
								res.props.templateId.toString(),
								newContract
							)
							.pipe(
								takeUntil(this.unsubscribe),
								finalize(
									(): boolean => (modal.componentInstance.btnDisable = false)
								)
							)
							.subscribe(
								({ data }): void => {
									this.messageService.showToaster(
										's_2',
										'contractTemplates',
										contract.name
									);
									this.contractToSaveId = data.id.toString();
									this.contractToSave = data;
									this.modalService.closeModalByRef(modal, modalSubscription$);
									this.contractTextSnapshot = null;
									this.saveAsTemplate();
								},
								(error): void => this.messageService.handleError(error)
							);
					}
				}
			);
		}
	}

	private saveNewContractTemplate(contract: Contract): void {
		const modal = this.modalService.openModal(SaveNewTemplateModalComponent, {
			windowClass: 'ng-bootstrap-modal'
		});
		modal.componentInstance.templateTypeName = 'Contract';
		modal.componentInstance.templateNameTitle = 'Contract';
		modal.componentInstance.breadcrumbsText =
			'Contract Templates will be saved in Settings > Contract Templates';
		modal.componentInstance.templateNameProp = contract.name;

		const modalSubscription$ = this.modalService.modalData.subscribe(
			(res: IModalAction<string>): void => {
				if (res.action === 'CLOSE') {
					this.confirmEditingContract(contract);
					this.modalService.closeModalByRef(modal, modalSubscription$);
				}

				if (res.action === 'SAVE') {
					if (!res.props || (res.props && !res.props.trim())) {
						this.messageService.showToaster('e_3', 'quoteInvoiceTemplates');
						return;
					}

					const newContract = JSON.parse(JSON.stringify(contract));
					newContract.name = res.props;

					modal.componentInstance.btnDisable = true;
					this.contractsDataService
						.saveNewContractTemplate(newContract)
						.pipe(
							takeUntil(this.unsubscribe),
							finalize(
								(): boolean => (modal.componentInstance.btnDisable = false)
							)
						)
						.subscribe(
							({ data }): void => {
								this.modalService.closeModalByRef(modal, modalSubscription$);
								this.messageService.showToaster(
									's_5',
									'quoteInvoiceTemplates',
									newContract.name
								);
								this.contractTextSnapshot = null;

								Observable.zip(
									this.templatesDataService.getTemplates('contract_preview'),
									this.getInitialContract()
								).subscribe(([contractTemplates, contractData]): void => {
									const contract = contractData ? contractData.contract : null;
									this.contractsTemplates = contractTemplates.contractTemplates;

									if (data) {
										this.setContractSources(data);
									} else if (contract) {
										this.qtTemplatesService.addSelectedTemplate(
											this.contractsTemplates,
											{
												...contract,
												templateId: contract.id
											}
										);

										this.linkedContract = contract;
										this.setContractSources(contract);
									}
									this.saveAsTemplate();
								});
							},
							(error): void => this.messageService.handleError(error)
						);
				}
			}
		);
	}

	private validateAndGatherTemplate(
		templateName: string
	): QTSaveDataPayload | null {
		const paymentScheduleTemplateId =
			this.paymentScheduleTemplateId !== 0
				? this.paymentScheduleTemplateId
				: this.paymentScheduleIdFromServer;

		const data = {
			contractTemplateId: this.contractToSave
				? this.contractToSave.id.toString()
				: null,
			questionnaireTemplateId: this.questionnaireToSaveId
				? this.questionnaireToSaveId.toString()
				: null,
			paymentSchedulerTemplateId: paymentScheduleTemplateId
				? paymentScheduleTemplateId.toString()
				: null,
			data: {
				products: this.qtTemplatesService.mapLineItems([
					...this.products,
					...this.discounts
				]),
				name: templateName,
				notes: this.notesToSave
			},
			summary: this.summary
		} as Partial<QtBaseData>;

		if (
			!this.qtTemplatesService.validateSelectedTemplates(
				data,
				this.contractsTemplates,
				this.questionnaireTemplates,
				'INVOICE'
			)
		) {
			return null;
		}

		if (!this.qtTemplatesService.validateInvoiceTemplate(data)) {
			return null;
		}

		return this.qtTemplatesService.prepareTemplateForSave(data);
	}

	private assignInitialDataAsTemplate(
		invoice: Invoice,
		contract: Contract
	): void {
		this.initialDataAsTemplate = this.qtTemplatesService.createTemplateDataFromInvoice(
			invoice,
			contract,
			'INVOICE'
		);
		this.selectedInvoiceTemplate = JSON.parse(
			JSON.stringify(this.initialDataAsTemplate)
		);
		this.modifyContractBodyForDiff(contract);
		this.modifyProductsForDiff(
			this.editInvoice ? invoice.summary.items : [...this.products]
		);
	}

	private registerUpdateProductSubscription(): void {
		this.quoteUpdateService.updatedProductObservable
			.pipe(
				takeUntil(this.unsubscribe),
				filter((product): boolean => product !== null)
			)
			.subscribe(updatedProduct => {
				if (
					this.quoteUpdateService.validateProductsPropsDefined(this.products)
				) {
					this.updateInvoiceSummary(true);
				}
			});
	}

	private updateInvoiceProductProperties(product): void {
		this.products.forEach((packageItem, index) => {
			if (index === product.index) {
				this.products[index].price = product.product.price;
				this.products[index].quantity = product.product.quantity;
				this.products[index].discount = product.product.discount;
				this.products[index].taxType = product.product.taxType;
				this.products[index].amount = product.product.amount;
			}
		});
	}

	private showNewInvoice(jobId: number): void {
		this.paymentScheduleTemplateId = -2;
		this.selectedPaymentSchedule = null;
		this.setInvoiceIdAndDate(jobId);

		this.getNewInvoice();

		this.loadInvoiceTemplates();
		this.getPaymentsSchedules(null);
	}

	private getJobId(makeRequest: boolean): void {
		this.leadId = this.dataToGetInvoice.id;
		this.quoteDataService
			.getJobId(this.leadId)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data: number) => {
				this.jobId = data;
				this.dataToGetInvoice.id = this.jobId;
				if (makeRequest) {
					this.getInvoiceSourceData(this.dataToGetInvoice.invoiceID);
				} else {
					this.showNewInvoice(this.jobId);
				}
			});
	}

	private getInvoiceSourceData(id: number): void {
		this.invoicesDataService
			.getInvoiceForUpdate(id)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(data: Invoice): void => {
					this.successGetInvoiceData(data);
					this.getPaymentsSchedules(data.paymentsRule);
				},
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private successGetInvoiceData(invoice: Invoice): void {
		this.invoice = JSON.parse(JSON.stringify(invoice));
		this.job = this.invoice.job;

		if (invoice.paymentSchedule && invoice.paymentSchedule.id) {
			this.job.paymentScheduleId = invoice.paymentSchedule.id;
		}

		this.setMainInfoData(
			invoice.invoiceId,
			this.quoteUpdateService.setQuoteIssueDate(invoice.issueDate),
			this.invoice.poNumber
		);

		this.setInvoiceSources(invoice);
		this.loadInvoiceTemplates();
	}

	private setInvoiceSources(invoice: Invoice): void {
		const {
			contract,
			currencyAndTaxes,
			paymentSchedule,
			payments,
			questionnaire,
			paymentsRule
		} = invoice;
		this.currencyAndTax = currencyAndTaxes;
		if (paymentSchedule === null) {
			if (paymentsRule.strategy === 'NO_SPLIT_PAYMENTS') {
				this.paymentScheduleTemplateId = -2;
			} else if (paymentsRule.strategy === 'NONE') {
				this.paymentScheduleTemplateId = -1;
			}
		} else {
			this.paymentScheduleIdFromServer = paymentSchedule.id;
		}
		this.payments = this.addMissDateField(payments);
		this.paymentsFromServer = payments;
		this.paymentSchedule = paymentSchedule;

		if (contract !== null) {
			this.contract = contract;
		}
		if (questionnaire !== null) {
			this.questionnaireToSaveId = questionnaire.id;
			this.questionnaire = questionnaire;
		}

		this.setProductsAndDiscounts(invoice.summary.items);

		this.notesToSave = invoice.notes;
		this.summary = invoice.summary;

		this.getContractAndQuestionnaireInfo();
	}

	private setProductsAndDiscounts(items: Array<Product>): void {
		const {
			addons,
			discounts
		} = QuoteUpdateService.separateDiscountsAndProducts([...items]);
		this.products = addons;
		this.discounts = discounts;
	}

	private updateInvoiceSummary(needToUpdatePayments): void {
		const productsToCalculate = this.getProductsToSaveInvoice(false);
		// setTimeout fixes issue on Safari when id of product changes with delay
		setTimeout(() => {
			if (productsToCalculate && this.currencyAndTax) {
				this.quoteDataService
					.calculateProductsSummary(
						productsToCalculate,
						this.currencyAndTax.percentage,
						this.currencyAndTax.currency.symbol
					)
					.pipe(takeUntil(this.unsubscribe))
					.subscribe(
						data =>
							this.successUpdatePricesCalculation(
								data,
								needToUpdatePayments,
								productsToCalculate
							),
						error => this.messageService.showDefaultErrorMessage(error)
					);
			}
		}, 0);
	}

	private successUpdatePricesCalculation(
		data: Summary,
		needToUpdatePayments,
		productsToCalculate
	): void {
		this.summary = data;
		if (
			this.job &&
			this.invoice &&
			this.paymentScheduleNames &&
			needToUpdatePayments &&
			productsToCalculate.length > 0
		) {
			this.paymentScheduleComponent.getPaymentScheduleNew(
				this.paymentScheduleTemplateId,
				true,
				this.summary.total
			);
		} else if (this.summary && this.summary.total === 0) {
			setTimeout(() => {
				this.paymentScheduleComponent.hideAndResetPaymentSchedule();
			}, 500);
		}
	}

	private successGetCurrencyAndTaxes(data): void {
		this.currencyAndTax = {
			currency: {
				symbol: data.currencyDTO.symbol
			},
			percentage: data.percentage,
			taxName: data.taxName
		};
		this.updateInvoiceSummary(false);
	}

	private setMainInfoData(
		invoiceId: string,
		issueDate: IssueDateFormat,
		poNumber: string
	): void {
		this.mainInfoDataToSave = {
			invoiceId,
			issueDate,
			poNumber
		};
	}

	private addMissDateField(
		payments: Array<Payment | QuotePayments | InvoicePayment> = []
	): Array<Payment> {
		if (!payments) {
			return [];
		}
		return payments.map((payment: Payment) =>
			Object.assign(payment, { paymentDate: payment.due })
		);
	}

	/* API section and Service call section */

	private getNewInvoice(): void {
		this.jobDataService
			.getQuoteInvoiceJob(this.dataToGetInvoice.id)
			.pipe(
				takeUntil(this.unsubscribe),
				map((res: any): Job => res.data)
			)
			.subscribe((job: Job) => (this.job = job));
	}

	private getCurrencyAndTaxes(): void {
		this.settingsService
			.getCurrencyAndTaxes()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(data): void => {
					this.successGetCurrencyAndTaxes(data);
					this.currencyFlag = true;
				},
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private setInvoiceIdAndDate(id): void {
		this.invoicesDataService
			.getInvoiceIdAndDate(id)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data: InvoiceIdAndDate): void => {
				this.setMainInfoData(
					data.invoiceId,
					this.quoteUpdateService.setQuoteIssueDate(data.issueDate),
					null
				);
				this.getCurrencyAndTaxes();

				this.getContractAndQuestionnaireInfo();
				// TODO - refactor
				let intervalCounter = 0;
				const interval = setInterval(() => {
					if (this.currencyFlag) {
						if (!this.editInvoice) {
							this.addProduct();
						}
						this.currencyFlag = false;
						intervalCounter++;
					}
					if (this.contractFlag && intervalCounter == 1) {
						this.assignInitialDataAsTemplate(this.invoice, this.linkedContract);
						this.contractFlag = false;
						intervalCounter++;
					}
					if (intervalCounter > 1) {
						clearInterval(interval);
					}
				}, 200);
			});
	}

	private getInitialContract() {
		if (this.contract) {
			this.currentContractId = this.contract.id;
			return this.contractDataService.getContract(
				this.job.id,
				this.contract.id
			);
		}
		return new Observable((observer): void => {
			observer.next(null);
		});
	}

	private getProductsTemplates(): void {
		const pageRequest = QuoteUpdateService.getPageRequest();
		this.productPackagesDataService
			.getPackagesOrProducts(pageRequest)
			.subscribe(
				(data): void => {
					this.setProductsAndDiscountsNames(data.items);
				},
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private setProductsAndDiscountsNames(products) {
		const {
			packages,
			addons,
			discounts
		} = QuoteUpdateService.setPackagesAndAddons(products);
		this.productsNames = packages.concat(addons);
		this.discountsNames = discounts;
	}

	private loadInvoiceTemplates(): void {
		this.qtTemplatesDataService
			.getInvoiceTemplatesList(
				QuoteInvoiceTemplatesService.getTemplatesParameters()
			)
			.pipe(
				takeUntil(this.unsubscribe),
				map(
					({ data }): Array<QtTemplateListItem> =>
						(data ? data.samples.items : [])
				)
			)
			.subscribe(
				(templates: Array<QtTemplateListItem>): Array<QtTemplateListItem> =>
					(this.invoiceTemplates = templates),
				(error): void => this.messageService.handleError(error)
			);
	}

	private getBootstrapSettings(): void {
		this.settingsService.timeFormatSettings
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data: BootstrapSettings): void => {
				this.setCorrectDateFormat(data.dateFormat);
				this.invoiceTemplatesAvailable = data.qtTemplatesAvailable;
			});
	}

	private setCorrectDateFormat(format: string): void {
		switch (format) {
			case 'DD_MM_YYYY':
				this.datePlaceholder = 'dd/mm/yyyy';
				break;
			case 'MM_DD_YYYY':
				this.datePlaceholder = 'mm/dd/yyyy';
				break;
			default:
				this.datePlaceholder = '';
				break;
		}
	}

	private getPaymentsSchedules(paymentsRule: any): void {
		const params = {
			perPage: 500,
			page: 1,
			predicate: 'name',
			reverse: false
		};
		this.paymentsSchedulesDataService.getPaymentsSchedules(params).subscribe(
			(data): void => {
				if (paymentsRule && paymentsRule.strategy === 'NONE') {
					this.defaultPaymentScheduleNames = [
						{
							id: -1,
							name: 'Choose Payment Schedule',
							disabled: true
						},
						{
							id: -2,
							name: 'No Split Payments',
							disabled: false
						}
					];
				} else {
					this.defaultPaymentScheduleNames = [
						{
							id: -2,
							name: 'No split payments',
							disabled: false
						}
					];
				}
				this.paymentScheduleNames = data.results;
			},
			(error): void => this.messageService.showDefaultErrorMessage(error)
		);
	}

	private getContractAndQuestionnaireInfo(): void {
		Observable.zip(
			this.templatesDataService.getTemplates('contract_preview'),
			this.templatesDataService.getTemplates('questionnaire_preview'),
			this.getInitialContract()
		).subscribe(
			([contractTemplates, questionnaireTemplates, contractData]): void => {
				const contract = contractData ? contractData.contract : null;
				this.contractsTemplates = contractTemplates.contractTemplates;
				this.questionnaireTemplates =
					questionnaireTemplates.questionnaireTemplates;

				this.qtTemplatesService.addSelectedTemplate(
					this.questionnaireTemplates,
					this.questionnaire
				);

				if (contract) {
					this.qtTemplatesService.addSelectedTemplate(this.contractsTemplates, {
						...contract,
						templateId: contract.id
					});

					this.linkedContract = contract;
					this.setContractSources(contract);
				} else {
					this.linkedContract = null;
				}
				this.contractFlag = true;
				this.assignInitialDataAsTemplate(this.invoice, contract);
			},
			(error): void => this.messageService.showDefaultErrorMessage(error)
		);
	}

	private setContractSources(contract: Contract): void {
		this.contractToSave = JSON.parse(JSON.stringify(contract));
		this.contractToSaveId = contract.id.toString();
	}

	private getContractToEdit(contractId: string): void {
		if (contractId === '-1') {
			this.contractToSave = null;
			return;
		}

		if (
			this.linkedContract &&
			contractId === this.linkedContract.id.toString()
		) {
			this.contractToSave = JSON.parse(JSON.stringify(this.linkedContract));
			return;
		}

		if (this.contractToSaveId) {
			this.buttonDisable = true;
			this.templatesDataService
				.getTemplates('contract_full', +this.contractToSaveId)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize((): boolean => (this.buttonDisable = false))
				)
				.subscribe(
					(contract: Contract): void => {
						this.contractToSave = JSON.parse(JSON.stringify(contract));
					},
					(error): void => this.messageService.showDefaultErrorMessage(error)
				);
		}
	}

	openEditSelectContract(): void {
		const selectedModalRef = this.modalService.openModal(
			EditContractModalComponent,
			{
				windowClass: 'ng-bootstrap-modal modal-visible'
			}
		);
		selectedModalRef.componentInstance.isFixed = true;
		selectedModalRef.componentInstance.contractToEdit = JSON.parse(
			JSON.stringify(this.contractToSave)
		);
		selectedModalRef.componentInstance.action = 'SAVE_CONTRACT';

		this.contractTextSnapshot = this.contractToSave.text;

		this.subscribeToEditContractData(selectedModalRef);
	}

	private subscribeToEditContractData(modalRef: NgbModalRef): void {
		const modalDataSubscription = this.modalService
			.getModalData()
			.subscribe((data: PropsAction<Contract>): void => {
				if (data) {
					const { action, props } = data;
					if (action === 'SAVE_CONTRACT') {
						this.saveEditedContract(props);
						this.modalService.closeModalByRef(modalRef, modalDataSubscription);
					}

					if (action === 'CLOSE_MODAL') {
						this.modalService.closeModalByRef(modalRef, modalDataSubscription);
					}
				}
			});
	}

	private saveEditedContract(contract: Contract): void {
		if (contract && contract.name) {
			contract.name = this.stringModifierService.cutSelectedText(contract.name);

			this.messageService.showToaster(
				's_2',
				'contractTemplates',
				contract.name
			);
		}
		this.contractToSave = JSON.parse(JSON.stringify(contract));
	}

	/* Invoice validation and saving/updating section */

	private validateInvoice(): boolean {
		const dataToValidate = {
			amount: this.summary.subTotal,
			packages: [],
			payments: this.payments,
			paymentScheduleTemplateId: this.paymentScheduleTemplateId,
			discount: this.summary.discountValue,
			xeroStatus: this.invoice.xeroStatus,
			qbStatus: this.invoice.qbStatus,
			totalDue: this.summary.total,
			poNumber: this.mainInfoDataToSave.poNumber,
			pageName: 'invoicePage'
		};
		dataToValidate.packages = this.invoiceService.checkProductPackagesCorrectType(
			this.getProductsToSaveInvoice(false)
		);

		if (
			this.paymentsToSave.find(
				payment =>
					!payment.date && !payment.paymentDateWithRule.ruleExplanationHTML
			) !== undefined
		) {
			this.messageService.showToaster('e_11', 'editQuote');
			return false;
		}

		return this.invoiceService.isInvoiceValid(dataToValidate);
	}

	private getPaymentStrategy() {
		switch (this.paymentScheduleTemplateId) {
			case -2:
				return 'NO_SPLIT_PAYMENTS';
			default:
				return 'BY_PAYMENT_SCHEDULER';
		}
	}

	private gatherDataToSaveInvoice(): InvoiceDataToSave {
		return {
			invoiceData: {
				displayId: this.mainInfoDataToSave.invoiceId,
				issueDate: this.timeService.getDateInFormat(
					this.mainInfoDataToSave.issueDate.jsdate,
					'date'
				),
				poNumber: this.mainInfoDataToSave.poNumber,
				jobId: this.jobId,
				paymentScheduleId: this.setPaymentScheduleIdForSave(
					this.summary.total === 0 ? -2 : this.paymentScheduleTemplateId
				),
				notes: this.notesToSave,
				packages: this.getProductsToSaveInvoice(true),
				payments: this.summary.total === 0 ? [] : this.getPaymentsToSave(),
				paymentsStrategy: this.getPaymentStrategy()
			},
			removeContract: this.contractToSave === null,
			removeQuestionnaire: this.questionnaireToSaveId === '-1',
			questionnaire: this.getQuestionnaireState()
				? {
						templateId: this.questionnaireToSaveId
				  }
				: null,
			contract:
				this.contractToSave && this.contractToSave.signed
					? null
					: this.getContractToSave()
		};
	}

	private getProductsToSaveInvoice(needToRemoveId): Array<Product> {
		this.products = QuoteUpdateService.setFixedQuoteProducts(this.products);
		const productsToSave = this.products.map((productItem, index): Product =>
			Object.assign(productItem, {
				id: productItem.fromSettings && needToRemoveId ? null : productItem.id,
				order: index,
				price: needToRemoveId
					? this.stringModifierService.convertAmountIntoNumber(
							productItem.price
					  )
					: productItem.price
			})
		);
		this.discounts.forEach((discount, index): void => {
			productsToSave.push(
				Object.assign(discount, {
					id: discount.fromSettings && needToRemoveId ? null : discount.id,
					order: index,
					price: this.stringModifierService.convertAmountIntoNumber(
						discount.price
					),
					taxType: this.setTaxTypeForDiscount(productsToSave, discount.taxType)
				})
			);
		});
		return productsToSave;
	}

	private setTaxTypeForDiscount(productsToSave, previousTax) {
		return productsToSave[0] ? productsToSave[0].taxType : previousTax;
	}

	private setPaymentScheduleIdForSave(id) {
		switch (+id) {
			case 0:
				return this.paymentScheduleIdFromServer;
			case -1:
			case -2:
				return null;
			default:
				return this.paymentScheduleTemplateId;
		}
	}

	private getContractToSave(): Contract {
		if (this.contractToSave) {
			this.contractToSave.name = this.stringModifierService.cutSelectedText(
				this.contractToSave.name
			);
			/* Fix changed field for GDPR */
			if (this.contractToSave.optInConsentStatement) {
				this.contractToSave.optInConsent = this.contractToSave.optInConsentStatement;
				delete this.contractToSave.optInConsentStatement;
			}
			/*
      Fix backend grammar mistake
      showOTPinconsent => showOPTinconsent
       */
			if (this.contractToSave.showOtpInConsent) {
				this.contractToSave.showOptInConsent = this.contractToSave.showOtpInConsent;
				delete this.contractToSave.showOtpInConsen;
			}
			if (this.currentContractId === this.contractToSave.id) {
				this.contractToSave.contractId = this.currentContractId;
			} else {
				this.contractToSave.contractId = null;
			}
		}
		return this.contractToSave;
	}

	private getPaymentsToSave(): Array<Payment> {
		return this.paymentsToSave.map((payment): Payment => {
			let paymentToSave;
			if (payment.date) {
				const date = this.quoteUpdateService.getDate(payment.date.jsdate);
				paymentToSave = Object.assign(payment, {
					paymentDate: date,
					due: date
				});
			} else if (
				!payment.date &&
				(payment.paymentDateWithRule &&
					payment.paymentDateWithRule.ruleExplanationHTML)
			) {
				paymentToSave = Object.assign(payment, {
					paymentDate: null
				});
			} else {
				paymentToSave = payment;
			}
			return paymentToSave;
		});
	}

	private getQuestionnaireState(): boolean {
		let isQuestionnaireChanged = true;
		// Check if questionnaire wasn't changed during invoice update
		if (
			this.questionnaire &&
			+this.questionnaireToSaveId === this.questionnaire.id
		) {
			isQuestionnaireChanged = false;
		}
		// Check if we do not have selected questionnaire on invoice create
		if (
			(!this.questionnaire && !this.questionnaireToSaveId) ||
			this.questionnaireToSaveId === '-1'
		) {
			isQuestionnaireChanged = false;
		}
		return isQuestionnaireChanged;
	}

	private isContractSigned(): boolean {
		const { signed, signatures } = this.contractToSave;
		if (signatures) {
			const {
				photographerSignature,
				primarySignature,
				secondarySignature
			} = signatures;
			return (
				signed ||
				photographerSignature ||
				primarySignature ||
				secondarySignature
			);
		}
		return signed;
	}

	private updateInvoice(saveData: InvoiceDataToSave): void {
		this.invoicesDataService
			.updateInvoice(this.dataToGetInvoice.invoiceID, saveData)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize(() => (this.buttonDisable = false))
			)
			.subscribe(
				data => this.successCreateInvoice(data),
				error =>
					this.invoiceService.errorSaveInvoice(
						error,
						this.mainInfoDataToSave.invoiceId
					)
			);
	}

	private createInvoice(saveData: InvoiceDataToSave): void {
		this.invoicesDataService
			.saveNewInvoice(this.jobId, saveData)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize(() => (this.buttonDisable = false))
			)
			.subscribe(
				data => this.successCreateInvoice(data),
				error =>
					this.invoiceService.errorSaveInvoice(
						error,
						this.mainInfoDataToSave.invoiceId
					)
			);
	}

	private successCreateInvoice(data): void {
		this.invoiceService.successCreateInvoice(data).then(id => {
			if (id) {
				this.location.go(`/invoices/${id}`);
			} else {
				this.location.back();
			}
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/invoices/invoice-update/invoice-update.ts